/**
 * Identity-shared zod schemas for connector authors.
 *
 * Kept deliberately minimal so extracted connector packages validate URLs the
 * same way the built-ins do, without each redefining the rule.
 */

// Namespace import — the repo convention so bun --compile statically bundles
// zod and the binding survives under Bun (see core/bridge zod notes).
import * as z from "zod";

/** Validates a URL string (any scheme accepted by the URL constructor). */
export const urlSchema = z.string().url();
